import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";

const PHASES = [
  [0, "Thinking"],
  [2500, "Reading the community brain"],
  [7000, "Writing"],
  [20000, "Still working — long answer"],
];

export function ThinkingIndicator({ compact = false }) {
  const [label, setLabel] = useState(PHASES[0][1]);
  useEffect(() => {
    const timers = PHASES.slice(1).map(([ms, text]) => setTimeout(() => setLabel(text), ms));
    return () => timers.forEach(clearTimeout);
  }, []);
  return (
    <div className={`inline-flex items-center gap-2 ${compact ? "text-xs" : "text-sm"}`} data-testid="copilot-thinking" aria-live="polite">
      <span className="relative inline-flex h-4 w-4 items-center justify-center">
        <span className="absolute inset-0 rounded-full bg-redline-400/40 rl-sparkle-ring" />
        <Sparkles className="h-4 w-4 text-redline-500 rl-sparkle" strokeWidth={2.25} />
      </span>
      <span className="rl-shimmer-text font-semibold">{label}…</span>
    </div>
  );
}
